<div class="gt-filter-container">
  <span>
    <select
      id="clientId"
      class="input-sm"
      [(ngModel)]="client_key"
      (ngModelChange)="resetData($event)"
      required>
      @for (client of clients; track $index) {
<option [value]="client.client_key">{{ client.client_name }}</option>
}
    </select>
  </span>
  <span class="taxIdFilter">
    @if (taxIdLoader) {
<div class="filter-loader"><i class="fa fa-spinner fa-spin"></i></div>
}
    @if (!taxIdLoader) {
<select
      id="taxId"
      class="input-sm"
      [(ngModel)]="tax_id"
     
      required>
      @for (taxP of taxPlacements; track $index) {
<option [ngValue]="taxP">{{ taxP.placematName }}</option>
}
    </select>
}
  </span>
  <span class="btn btn-success btn-xs" (click)="getData()">Filter</span>
  <span class="btn btn-success btn-xs" style="margin-left: 5px;" (click)="openCreateTaxPlacematModal()">Create Tax Placemat</span>
  <button class="btn btn-danger btn-xs" type="button" style="margin-left: 5px;" (click)="deleteTaxPlacemat()">Delete Tax Placemat</button>
</div>

<div class="gt-page-header">
  <span><h1 class="ng-binding">Tax Placemat - {{ tax_id?.placematName || 'Admin' }}</h1></span>
  <span class="btn btn-success btn-xs" (click)="createType('createProcBlock')">Create Process</span>
</div>

<div class="taxPlacematContainer">
  <div class="row">
    <div class="col-md-6" style="padding-right: 0;">
      <div class="row margin">
        @if (createProcBlock) {
<div class="col-md-12 createBlock">
          <form>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-md-9" style="padding-left: 26px;">
                <input
                  type="text"
                  class="form-control input-sm"
                  placeholder="Enter Process Name"
                  [(ngModel)]="processName"
                  name="processName" />
              </div>
              <div class="col-md-3 no-padding-left">
                <button class="btn btn-xs btn-info" type="button" (click)="addProc(processName)">Add Process</button>
                <button
                  class="btn btn-xs btn-warning"
                  type="button"
                  (click)="cancelType('createProcBlock', ['processName', 'tax_year_begin', 'tax_year_end'])">
                  Cancel
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="col-md-5">Beginning period:</label>
                <div class="col-md-7">
                  <input type="date" class="form-control input-sm" [(ngModel)]="tax_year_begin" name="tax_year_begin" />
                </div>
              </div>
              <div class="col-md-6">
                <label class="col-md-5">Ending period:</label>
                <div class="col-md-7">
                  <input type="date" class="form-control input-sm" [(ngModel)]="tax_year_end" name="tax_year_end" />
                </div>
              </div>
            </div>
          </form>
        </div>
}
      </div>

      @if (showBlock) {
<div class="col-md-12">
        <div class="mappedProcBlock">
          <div class="row procSaveBlock">
            <div class="col-md-4">
              <button class="btn btn-success btn-xs" (click)="reorderProcessModal()">Reorder Processes</button>
            </div>
            <div class="col-md-8" style="text-align: right;">
              <button class="btn btn-xs btn-info" type="button" (click)="saveTasks()">
                <span>@if (saveloader) {
<i class="fa fa-spinner fa-pulse"></i>
}</span> Save
              </button>
              @if (!newTaxPlacemat) {
<button class="btn btn-xs btn-warning" type="button" (click)="clearTasks()">Clear</button>
}
            </div>
          </div>
          <div class="mappedProcSection">
            <div class="mappedProcInnerSection customScroll">
              @for (processes of mappedProcessesList; track $index; let i = $index) {
<div class="processList">
                <div class="panel panel-default">
                  <div class="row panel-heading map-btn-block">
                    <div class="col-sm-12 no-padding-left no-padding-right">
                      <span class="col-md-4 no-padding-left">
                        <span class="radioBtn no-padding-left" style="padding-right: 10px;">
                          <input type="radio" name="process" [value]="i" [ngModel]="selectedProc" (ngModelChange)="selectedProcess(processes, i)">
                        </span>
                        <span class="badge proc-index">{{ i + 1 }}</span>
                        <span class="procName">{{ processes.label }}</span>
                      </span>
                      <span class="col-md-3" style="margin-top: 2px;">
                        <span class="procName">{{ processes.process_from | date: 'MM/dd/yyyy' }}</span>
                      </span>
                      <span class="col-md-2" style="margin-top: 2px;">
                        <span class="procName">{{ processes.process_to | date: 'MM/dd/yyyy' }}</span>
                      </span>
                      @if (processes.edit_delete) {
<span class="col-md-1 edit-block">
                        <span class="add_edit" (click)="openDummyActivityModal()"><i class="fa fa-plus-square"></i></span>
                      </span>
}
                      @if (processes.edit_delete) {
<span class="col-md-1 edit-block">
                        <span class="add_edit" (click)="editProcess(i)"><i class="fa fa-edit"></i></span>
                      </span>
}
                      @if (processes.edit_delete) {
<span class="col-md-1 no-padding-right">
                        <button
                          style="float: right;"
                          class="btn btn-xs btn-danger fa fa-times deleteProcBtn"
                          type="button"
                          (click)="deleteProc(processes.process_id, i)">
                        </button>
                      </span>
}
                    </div>
                  </div>
                  @if (processes.edit) {
<div class="row panel-heading map-btn-block" style="background-color: #f5f5f5 !important;">
                    <div class="col-sm-12 no-padding-left no-padding-right">
                      <div class="col-md-4 no-padding-left">
                        <input type="text" class="form-control input-sm" [(ngModel)]="processes.label" name="label_{{i}}">
                      </div>
                      <div class="col-md-3 no-padding-left">
                        <input type="date" class="form-control input-sm" [(ngModel)]="processes.process_from" name="from_{{i}}">
                      </div>
                      <div class="col-md-3 no-padding-left">
                        <input type="date" class="form-control input-sm" [(ngModel)]="processes.process_to" name="to_{{i}}">
                      </div>
                      <div class="col-md-2 no-padding-right" style="margin-top: 3px;">
                        <span class="save_cancel" (click)="saveProcess(processes, i)"><i class="fa fa-save"></i></span>
                        <span class="save_cancel" style="float: right;" (click)="cancelEdit(i)"><i class="fa fa-times-circle"></i></span>
                      </div>
                    </div>
                  </div>
}
                  <div class="row main-header">
                    <div class="col-sm-3"><span>Number</span></div>
                    <div class="col-sm-9"><span>Activity Name</span></div>
                  </div>
                  <div
                    class="row main-body"
                    cdkDropList
                    id="mapped-process-drop-list"
                    [cdkDropListData]="processes.children"
                    [cdkDropListConnectedTo]="getConnectedDropListIds()"
                    (cdkDropListDropped)="dropMapped($event)">
                    @for (tasks of processes.children; track $index; let j = $index) {
<div class="main-body-data drag-item" cdkDrag>
                      <div class="col-sm-3">
                        <span class="badge btn-info">{{ j + 1 }}</span>
                      </div>
                      <div class="col-sm-9">
                        <span>{{ tasks.activity_name }}</span>
                        @if (tasks.dummy_activity) {
<span class="dummyActivity">{{ tasks.placemat_name }}</span>
}
                      </div>
                    </div>
}
                    @if (processes.children?.length === 0) {
<div class="noActBlock">No Activity Added.</div>
}
                  </div>
                </div>
              </div>
}
            </div>
          </div>
        </div>
      </div>
}
    </div>

    @if (showBlock) {
<div class="col-md-6 no-padding-left">
      <div class="row" style="margin:10px 5px 0px 5px">
        <div class="col-md-12">
          <div class="panel panel-default">
            <div class="panel-heading">
              Select Activity for :
              <span class="selectedProc">{{ mappedProcessesList[current_process]?.label }}</span>
            </div>
            <div class="bussinessHierarchySection">
              <div class="bussinessHierarchyInnerSection customScroll">
                @for (task of tasksList; track $index; let taskIndex = $index) {
<div class="tasks-block">
                  <span class="taskSelect">
                    <input
                      type="checkbox"
                      class="proc-select"
                      [(ngModel)]="task.selected"
                      (change)="updateSelected(task, 'parent', undefined, undefined, $event)">
                  </span>
                  <span class="taskName taskSelect">{{ task.task_name }}</span>
                  <span class="folderIcon" (click)="toggleActivities(taskIndex)">
                    @if (task.selectedTaskCount > 0) {
<span class="badge activity_selected">{{ task.selectedTaskCount }}</span>
}
                    @if (task.toggle) {
<i class="fa fa-folder-open"></i>
}
                    @if (!task.toggle) {
<i class="fa fa-folder"></i>
}
                  </span>
                  @if (task.toggle) {
<div
                    class="activityBlock row main-body"
                   
                    cdkDropList
                    [id]="getSourceListId(taskIndex)"
                    [cdkDropListData]="task.children"
                    [cdkDropListConnectedTo]="getConnectedDropListIds()"
                    (cdkDropListDropped)="dropSource($event)">
                    @for (activity of task.children; track $index; let activityIndex = $index) {
<div
                      class="subTask drag-item"
                      cdkDrag
                     >
                      <span>
                        <input
                          type="checkbox"
                          class="proc-select task-select"
                          [(ngModel)]="activity.selected"
                          (change)="updateSelected(task, 'child', activity, undefined, $event)">
                      </span>
                      <span style="padding-left: 20px;">{{ activity.activity_name }}</span>
                      @if (activity.subtask) {
<span class="folderIcon" style="margin-top: 0;" (click)="activity.toggle = !activity.toggle">
                        @if (activity.selectActivityCount > 0) {
<span class="badge activity_selected">{{ activity.selectActivityCount }}</span>
}
                        @if (activity.toggle) {
<i class="fa fa-folder-open"></i>
}
                        @if (!activity.toggle) {
<i class="fa fa-folder"></i>
}
                      </span>
}
                      @if (activity.subtask && activity.toggle) {
<div
                        class="child_act"
                       
                        cdkDropList
                        [id]="getSourceListId(taskIndex, activityIndex)"
                        [cdkDropListData]="activity.children"
                        [cdkDropListConnectedTo]="getConnectedDropListIds()"
                        (cdkDropListDropped)="dropSource($event)">
                        @for (childActivity of activity.children; track $index) {
<div class="subTask drag-item" cdkDrag>
                          <span>
                            <input
                              type="checkbox"
                              class="proc-select task-select"
                              [(ngModel)]="childActivity.selected"
                              (change)="updateSelected(task, 'subchild', activity, childActivity, $event)">
                          </span>
                          <span style="padding-left: 20px;">{{ childActivity.activity_name }}</span>
                        </div>
}
                      </div>
}
                    </div>
}
                  </div>
}
                </div>
}
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
}
  </div>

  @if (showProcLoader) {
<div class="viewProcLoader col-md-12">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (defaultClient) {
<div class="row noBussinessFound">
    <label><strong>No processes found</strong></label>
  </div>
}
</div>

@if (showCreateTaxPlacematModal) {
<div class="pm-modal-overlay">
  <div class="pm-modal">
    <div class="modal-header">
      <h4 class="modal-title">Create Tax Placemat <i class="fa fa-times pull-right" (click)="closeCreateTaxPlacematModal()"></i></h4>
    </div>
    <div class="modal-body">
      <input type="text" class="form-control input-sm" [(ngModel)]="taxPlacematName" placeholder="Tax placemat name">
    </div>
    <div class="modal-footer">
      <button class="save-button" type="button" (click)="createTaxPlacemat()">Create</button>
      <button class="cancel-button" type="button" (click)="closeCreateTaxPlacematModal()">Cancel</button>
    </div>
  </div>
</div>
}

@if (showDummyActivityModal) {
<div class="pm-modal-overlay">
  <div class="pm-modal">
    <div class="modal-header">
      <h4 class="modal-title">Add Dummy Activity <i class="fa fa-times pull-right" (click)="closeDummyActivityModal()"></i></h4>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Tax Placemat</label>
        <select class="form-control input-sm" [(ngModel)]="dummySelectedPlacemat" [ngModelOptions]="{standalone: true}">
          @for (taxP of taxPlacements; track $index) {
<option [ngValue]="taxP">{{ taxP.placematName }}</option>
}
        </select>
      </div>
      <div class="form-group">
        <label>Activity Name</label>
        <input type="text" class="form-control input-sm" [(ngModel)]="dummyActivityName" placeholder="Dummy Activity Name">
      </div>
    </div>
    <div class="modal-footer">
      <button class="save-button" type="button" (click)="createDummyActivity()">Add</button>
      <button class="cancel-button" type="button" (click)="closeDummyActivityModal()">Cancel</button>
    </div>
  </div>
</div>
}

@if (showReorderModal) {
<div class="pm-modal-overlay">
  <div class="pm-modal pm-modal-md">
    <div class="modal-header">
      <h4 class="modal-title">Reorder Processes <i class="fa fa-times pull-right" (click)="closeReorderModal()"></i></h4>
    </div>
    <div class="modal-body">
      @for (process of reorderProcesses; track $index; let i = $index) {
<div class="reorder-row">
        <span>{{ i + 1 }}. {{ process.label }}</span>
        <span class="reorder-actions">
          <i class="fa fa-arrow-up" (click)="moveReorderUp(i)"></i>
          <i class="fa fa-arrow-down" (click)="moveReorderDown(i)"></i>
        </span>
      </div>
}
    </div>
    <div class="modal-footer">
      <button class="save-button" type="button" (click)="applyReorder()">Apply</button>
      <button class="cancel-button" type="button" (click)="closeReorderModal()">Cancel</button>
    </div>
  </div>
</div>
}
